<template>
  <div class="row">
    <div class="col-sm-6">
      <stock-rotations-form :init-product="queryProduct" @stockRotationsCreated="stockRotationsCreated" />
    </div>
    <div class="col-sm-6">
      <div class="el-tabs el-tabs--top el-tabs--border-card card">
        <div class="el-tabs__header is-top">
          <div class="el-tabs__nav-wrap is-top">
            <div class="el-tabs__nav-scroll">
              <div role="tablist" class="el-tabs__nav is-top is-stretch" style="transform: translateX(0px);">
                <div class="el-tabs__item is-top" :class="sidebarType === 'rotations' ? 'is-active' : ''"
                  @click="sidebarType = 'rotations'">
                  Letzte Lagerbewegungen
                </div>
                <div class="el-tabs__item is-top" :class="sidebarType === 'products' ? 'is-active' : ''"
                  @click="sidebarType = 'products'">
                  Zu bestellende Produkte
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="el-tabs__content">
          <div role="tabpanel" id="pane-Route" aria-labelledby="tab-Route" class="el-tab-pane">
            <transition name="el-fade-in-linear">
              <div v-if="sidebarType === 'rotations'">
                <h4 class="card-title">Letzte Lagerbewegungen</h4>
                <div style="overflow-x: auto; margin-top: 0.75em;">
                  <table class="table table-striped table-bordered" style="margin-top: 0.75em;">
                    <thead>
                      <tr>
                        <th>Datum</th>
                        <th>Produkt</th>
                        <th>Menge</th>
                        <th>Preis</th>
                        <th v-if="warehouses.length > 1">Lager</th>
                        <th>Grund</th>
                        <th>User</th>
                        <th>Kostenstelle</th>
                        <th>&nbsp;</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr is="StockRotationRow" v-for="lastStockRotation in last20StockRotations"
                        :key="lastStockRotation.id" :stock-rotation="lastStockRotation" :accumulated="false"
                        :show-warehouse="warehouses.length > 1" @deleteStockRotation="deleteStockRotation" />
                    </tbody>
                  </table>
                </div>
              </div>
              <div v-if="sidebarType === 'products'">
                <h4 class="card-title" style="margin-bottom: 0.75rem;">Zu bestellende Produkte</h4>
                <div v-for="warehouseData in productsToOrder" :key="warehouseData.warehouse.id">
                  <transition name="el-fade-in-linear">
                    <div v-if="warehouseData.products.length">
                      <router-link :to="`/warehouses/${warehouseData.warehouse.id}/products/to_order`" style="font-size: 1.25rem;">
                        {{ warehouseData.warehouse.name }}
                      </router-link>
                      <table class="table table-striped table-bordered">
                        <thead>
                          <tr>
                            <th>Produkt</th>
                            <th>Auf Lager</th>
                            <th>Warnschwelle</th>
                            <th>Lager Sollmenge</th>
                            <th>Offene Bestellungen</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="product in warehouseData.products" :key="product.id">
                            <td>
                              <router-link :to="`/products/${product.id}`">
                                {{ product.name }}
                              </router-link>
                              <span v-if="product.lager_soll_menge">
                                ({{ product.lager_soll_menge - product.quantity }})
                              </span>
                            </td>
                            <td class="text-right">{{ product.quantity || 0 }}</td>
                            <td class="text-right">{{ product.warnschwelle_config }}</td>
                            <td class="text-right">{{ product.soll_menge_config }}</td>
                            <td class="text-right">{{ product.ordered_quantity || 0 }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </transition>
                </div>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StockRotationsForm from 'src/pages/StockRotations/stock-rotations-form'
import StockRotationRow from 'src/pages/StockRotations/stock-rotation-row'
import { Tabs, TabPane } from 'element-ui'


export default {
  components: {
    StockRotationsForm,
    StockRotationRow,
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
  },
  data() {
    return {
      sidebarType: 'rotations',
      warehouses: [],
      productsToOrder: [],
      lastStockRotations: [],
      queryProduct: null
    }
  },
  methods: {
    async deleteStockRotation(stockRotation) {
      if (confirm('Lagerbewegung wirklich löschen?')) {
        await this.initCsrf()

        this.$http.delete(`/stock_rotations/${stockRotation.id}`).then(({ data }) => {
          this.$notify({
            message: `Lagerbewegung erfolgreich gelöscht.`,
            type: 'success'
          })
          const index = this.lastStockRotations.findIndex(({ id }) => data.id === id)
          this.lastStockRotations.splice(index, 1)
        })
      }
    },
    stockRotationsCreated(...stockRotations) {
      console.log(...stockRotations)
      this.lastStockRotations.unshift(...stockRotations)
    }
  },
  computed: {
    last20StockRotations() {
      if (this.lastStockRotations.length > 20) {
        return this.lastStockRotations.slice(0, 20)
      }
      return this.lastStockRotations
    }
  },
  created() {
    if (this.$route.query['product']) {
      this.$http.get(`/products/${this.$route.query['product']}`).then(({ data }) => {
        this.queryProduct = data
      })
    }
    this.$http.get(`/warehouses`).then(({ data }) => {
      this.warehouses = data
    })
    this.$http.get(`/products/to_order`).then(({ data }) => {
      this.productsToOrder = data
    })
    this.$http.get('/stock_rotations?limit=20').then(({ data }) => {
      this.lastStockRotations = data
    })
  }
}
</script>

<style>
.form-check-inline {
  vertical-align: sub;
}
</style>
